/* @flow */
import apiRequest from 'lib/apiRequest';
import Entity from 'lib/Entity';

export default class PaymentSource extends Entity {
  getBrand() {
    return this.get('brand');
  }

  getLastFourDigit() {
    return this.get('last4');
  }

  getExpMonth() {
    return this.get('exp_month');
  }

  getExpYear() {
    return this.get('exp_year');
  }

  getExpirationDate() {
    return this.getExpMonth() + '/' + String(this.getExpYear()).slice(-2);
  }

  delete() {
    return apiRequest(`/payments/payment_sources/${this.id}`, 'DELETE');
  }

  static create(token) {
    return (
      apiRequest('/payments/payment_sources', 'POST', { token })
      .then(paymentSource => PaymentSource.fromJSON(paymentSource))
    );
  }
}



// WEBPACK FOOTER //
// ./src/entities/PaymentSource.js